import { SvgProps } from "types/layout-types"

export const SvgList = ({ className, onClick }: SvgProps) => {
    return (
        <>
            <svg className={className} viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
                <path d="M223.999,128.00037a8.00039,8.00039,0,0,1-8,8h-176a8,8,0,0,1,0-16h176A8.00039,8.00039,0,0,1,223.999,128.00037Zm-184-56h176a8,8,0,0,0,0-16h-176a8,8,0,1,0,0,16Zm176,112h-176a8,8,0,0,0,0,16h176a8,8,0,0,0,0-16Z" />
            </svg>
        </>
    )
}